import { GetDoctorSpecialty } from 'domain/usecases/doctor/get-doctor-specialty'
import { DoctorRepository } from 'repository/interfaces/doctor-repository'

export class RemoteGetDoctorSpecialty implements GetDoctorSpecialty {
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  getDoctorSpecialty(
    params: GetDoctorSpecialty.Params
  ): Promise<GetDoctorSpecialty.Model> {
    return this.doctorRepository.getDoctorSpecialty(params)
  }
}
